export default "/images/arrow.svg?20efb56558cb5c54c132a28082c6cc20";